/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Table_Col_RequestedInputs */

const vi_await_table_col_requested = /** @type {(inputs: Await_Table_Col_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số mua`)
};

/**

* @param {Await_Table_Col_RequestedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_table_col_requested = /** @type {((inputs?: Await_Table_Col_RequestedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Table_Col_RequestedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_table_col_requested(inputs)
});